import onetime from "@-/com.npmjs.onetime";
import type { AuthMethod } from "#analytics-event";

/** A hint older than this belongs to an abandoned attempt, not to the session that resolved now. */
const AUTH_METHOD_HINT_TTL_MS = 10 * 60 * 1000;

const getHintState = onetime((): { hint: { at: number; method: AuthMethod } | null } => ({
  hint: null,
}));

/**
 * Records how the user is authenticating. The session resolves elsewhere (Better Auth's session
 * store), so the identity layer reads this back to label `account_authenticated`.
 */
export function noteAuthMethod(method: AuthMethod): void {
  getHintState().hint = { at: Date.now(), method };
}

/** Returns the pending hint, if still fresh, and clears it. */
export function consumeAuthMethodHint(): AuthMethod | undefined {
  const state = getHintState();
  const { hint } = state;
  state.hint = null;
  if (hint === null || Date.now() - hint.at > AUTH_METHOD_HINT_TTL_MS) {
    return undefined;
  }
  return hint.method;
}
